import { ApiSignInAgentWithOtpResponse } from 'src/app/core/models';

export const signInAgentWithOtp = (): ApiSignInAgentWithOtpResponse => ({
  token: 'thisIsATestIPIMSToken',
  patientId: 12345,
  username: 'agent.username',
});
